module.exports = __webpack_public_path__ + "img/2cbfb9408e25522f449412d77ae5fc16a4f633fa.3fadd078.png";